import { Variables } from '../../base';

export const PDF_BACKGROUND_COLOR = Variables.Colors.n15_24;

export const PDF_OFFSCREEN_LEFT = '-10000px';
export const ONE_INCH_WIDTH = '1in';

/** Letter page (inches) and CSS px/in used for html2pdf capture sizing. */
export const STATEMENT_PRINT_PAGE_WIDTH_IN = 8.5;
export const STATEMENT_PRINT_PAGE_HEIGHT_IN = 11;
/**
 * Side/top/bottom PDF margins are 0 — `.ps-paper` padding is the inset.
 * Non-zero side margins + 816px paper clipped the right edge (816px ≈ full 8.5in).
 */
export const STATEMENT_PRINT_MARGIN_TOP_IN = 0;
export const STATEMENT_PRINT_MARGIN_BOTTOM_IN = 0;
export const STATEMENT_PRINT_MARGIN_SIDE_IN = 0;
export const STATEMENT_PRINT_CSS_PX_PER_IN = 96;
export const STATEMENT_PRINT_PAPER_WIDTH_PX = Math.round(
    STATEMENT_PRINT_PAGE_WIDTH_IN * STATEMENT_PRINT_CSS_PX_PER_IN,
);

/**
 * html2canvas clips centered (margin:auto) paper when the capture host is wider
 * than .ps-paper — force left alignment + contain overflow for PDF capture only.
 */
export const forceStatementPaperLeftAligned = (root: ParentNode): void => {
    root.querySelectorAll('.ps-paper').forEach(node => {
        const paper = node as HTMLElement;
        paper.style.setProperty('margin', '0', 'important');
        paper.style.setProperty('margin-left', '0', 'important');
        paper.style.setProperty('margin-right', '0', 'important');
        paper.style.setProperty('width', '100%', 'important');
        paper.style.setProperty('max-width', '100%', 'important');
        paper.style.setProperty('overflow-x', 'hidden', 'important');
        paper.style.setProperty('overflow-y', 'visible', 'important');
        paper.style.setProperty('box-sizing', 'border-box', 'important');
    });
};
